import { SETTINGS_CARDS_TOKENS } from "frontend/constants/settings"

const SettingsShiftsPage = () => import('frontend/pages/settings/shifts/SettingsShiftsPage')
const SettingsSystemsPage = () => import('frontend/pages/settings/SettingsSystemsPage')


export const settingsShiftRoutesOptions = [
  {
    path: 'shift-management',
    name: SETTINGS_CARDS_TOKENS.shifts.name,
    component: SettingsShiftsPage,
  },
]

export const settingsSystemRoutesOptions = [
  {
    path: 'system',
    name: SETTINGS_CARDS_TOKENS.configSettingsOverview.name,
    component: SettingsSystemsPage,
    props: { source: 'people' },
  },
]
